import { render, staticRenderFns } from "./UITotalFooter.vue?vue&type=template&id=0980403c"
import script from "./UITotalFooter.vue?vue&type=script&lang=js"
export * from "./UITotalFooter.vue?vue&type=script&lang=js"
import style0 from "./UITotalFooter.vue?vue&type=style&index=0&id=0980403c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports